(function () {
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-predictive-quick-add]');
    if (!button || button.classList.contains('loading')) return;

    event.preventDefault();

    const variantId = button.dataset.predictiveQuickAdd;
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const spinner = button.querySelector('.loading__spinner');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');
    if (spinner) spinner.classList.remove('hidden');

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          const label = button.querySelector('span');
          if (label) {
            const originalText = label.textContent;
            label.textContent = response.description || response.message || originalText;
            setTimeout(function () {
              label.textContent = originalText;
            }, 3000);
          }
          return;
        }

        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response,
          });
        }

        if (!cart) {
          window.location = routes.cart_url;
          return;
        }

        cart.renderContents(response);
      })
      .catch((error) => console.error(error))
      .finally(() => {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  });
})();
